<template>
  <svg :width="width" :height="height" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="15" cy="15" r="14" fill="white" stroke="#80B7FF" stroke-width="2"/>
<path d="M13.6641 8.33398L12.9974 9.00065H10.3307C9.93073 9.00065 9.66406 9.26732 9.66406 9.66732C9.66406 10.0673 9.93073 10.334 10.3307 10.334H11.6641H18.3307H19.6641C20.0641 10.334 20.3307 10.0673 20.3307 9.66732C20.3307 9.26732 20.0641 9.00065 19.6641 9.00065H16.9974L16.3307 8.33398H13.6641ZM10.3307 11.6673V20.334C10.3307 21.0673 10.9307 21.6673 11.6641 21.6673H18.3307C19.0641 21.6673 19.6641 21.0673 19.6641 20.334V11.6673H10.3307ZM12.9974 13.0007C13.3974 13.0007 13.6641 13.2673 13.6641 13.6673V19.6673C13.6641 20.0673 13.3974 20.334 12.9974 20.334C12.5974 20.334 12.3307 20.0673 12.3307 19.6673V13.6673C12.3307 13.2673 12.5974 13.0007 12.9974 13.0007ZM16.9974 13.0007C17.3974 13.0007 17.6641 13.2673 17.6641 13.6673V19.6673C17.6641 20.0673 17.3974 20.334 16.9974 20.334C16.5974 20.334 16.3307 20.0673 16.3307 19.6673V13.6673C16.3307 13.2673 16.5974 13.0007 16.9974 13.0007Z" fill="#80B7FF"/>
</svg>

</template>

<script>
import { colors } from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 30 },
    height: { type: [Number, String], default: 30 },
    color: { type: String, default: colors.iconArinet },
  },
};
</script>
